export default null;throw new Error("Unable to resolve \"./sync-inflate\" from npm:pngjs@5.0.0/browser.js");